import React, { useEffect, useState } from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
import pdficon from "../images/pdf-icon.jpg";

function StaffNoc() {
  const [downloads, setDownloads] = useState([]);
  const RUrlmain = "https://gcbeetan.co.in/admin/downloads/"; // backend file path

  useEffect(() => {
    fetch("https://gcbeetan.co.in/admin/api/downloads.php?category=3") // 3 = Staff NOC
      .then((res) => res.json())
      .then((data) => setDownloads(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <>
      <Header />
      <div className="section">
        {/* Title Section */}
        <section
          className="content-section title-top"
          style={{ backgroundImage: `url(${topback})` }}
        >
          <div className="pattern-overlay">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 title-heading">
                  <h2>Staff → NOC</h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Downloads List */}
        <div className="container mt-4">
          {downloads.length > 0 ? (
            downloads.map((item) => {
              const downloadLink = item.file
                ? `${RUrlmain}${encodeURIComponent(item.file)}`
                : item.externalurl;

              return (
                <div className="row mb-3 align-items-center" key={item.id}>
                  {/* File Icon */}
                  <div className="col-2 text-center">
                    <img
                      className="border rounded pdficon"
                      src={pdficon}
                      alt="file icon"
                      style={{ width: "128px" }}
                    />
                  </div>

                  {/* Title */}
                  <div className="col-6">
                    <p className="pdfpara">
                      <a href={downloadLink} target="_blank" rel="noreferrer">
                        <strong>{item.title}</strong>
                      </a>
                    </p>
                  </div>

                  {/* Spacer */}
                  <div className="col-2"></div>

                  {/* Download Button */}
                  <div className="col-2 text-center">
                    <a
                      href={downloadLink}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-back"
                      style={{ width: "150px", height: "36px" }}
                    >
                      Download <i className="icon ion-ios-arrow-thin-down"></i>
                    </a>
                  </div>
                </div>
              );
            })
          ) : (
            <p>No downloads available in this category.</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default StaffNoc;
